import Sider from "antd/es/layout/Sider";
import { useState } from "react";
import SidebarItems from "./sidebarItems";

export default function SideBar({ defaultSelectedKeys }: any) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
      style={{ background: "#1D1F5D" }}
    >
      <SidebarItems />
    </Sider>
  );
}
